module.exports = __webpack_public_path__ + "static/media/testimonial2.7d933561.jpg";